import { Applicant } from 'store/dashboard/types'
import { formatNumber } from 'store/utils'

//Filters also by default IP Weight
export const filterAndSortByPurePlay = (
  targetCompany: Applicant,
  groupedApplicants: Applicant[], //TODO rename to applicants
  topCompaniesNumber: number,
  selectedGroups: string[], //TODO rename to subgroupsSelected
  ipWeight?: number,
) => {
  const ipWeightFinal = ipWeight
    ? ipWeight
    : targetCompany.whales_patents_in_categories < 10
      ? targetCompany.whales_patents_in_categories
      : 10
  const groupedApplicantsFilterByIpWeight = groupedApplicants.filter(d => d.whales_patents_in_categories >= ipWeightFinal)

  const sortedByPurePlayDataset = groupedApplicantsFilterByIpWeight
    .filter(d => d.applicant_original_name !== targetCompany.applicant_original_name)
    .filter(d => !d.research)
    .map(d => {
      //recalculate the whales in percent based on the selected subgroups
      let totalPatentCount = d.whales_patent_count
      let total_patents_in_selected_subgroups = selectedGroups.reduce(
        (sum, group) => sum + (d.whales_count_by_ipcr[group] || 0),
        0,
      )

      // Calculate the percentage
      const whales_patent_in_percent = totalPatentCount > 0 ? (total_patents_in_selected_subgroups / totalPatentCount) * 100 : 0

      // return updated object with new percentage based on selected subgroups
      return {
        ...d,
        whales_patent_in_percent,
      }
    })
    .sort((a, b) => b.whales_patent_in_percent - a.whales_patent_in_percent) // whales_patent_in_percent === purePlayRatio
    .slice(0, topCompaniesNumber - 1) // -1 because we already have the targetCompany in the chartData
  return sortedByPurePlayDataset
}

export const calculateGap = (targetCompany: Applicant, competitors: Applicant[]) => {
  //sector == subgroup
  const averageCompetitors = formatNumber(
    competitors.reduce((acc, curr) => acc + curr.whales_patent_in_percent, 0) / competitors.length,
  )
  const gap = competitors.length > 0 ? targetCompany.whales_patent_in_percent - averageCompetitors : 100
  return gap
}

export const getNewPercentage = (company: Applicant, selectedSubgroups: string[]): number => {
  let totalPatentCount = company.whales_patent_count
  let total_patents_in_selected_subgroups = selectedSubgroups.reduce(
    (sum, group) => sum + (company.whales_count_by_ipcr[group] || 0),
    0,
  )

  // Calculate the percentage
  const whales_patent_in_percent = totalPatentCount > 0 ? (total_patents_in_selected_subgroups / totalPatentCount) * 100 : 0

  return whales_patent_in_percent
}
